import React, { useContext } from "react";
import Incomplete_svg from "../../../../svg/svg-modal/Incomplete_svg";
import ModalBox from "../../../../common/component/Modal/Index";
import instance from "../../../../common/api/interceptor";
import { path } from "../../../../constants/apiPath";
import { StoreContext } from "../../../../store";
import { NotificationManager } from "react-notifications";
import moment from "moment";
import { OrderContext } from "../../../orderList/store";

function EmptyData(props) {
  const context = useContext(StoreContext);

  const { placedData, setPlacedData } = useContext(OrderContext);

  // const onNextHandler = (path) => {
  //   onPostOrder(path, body);
  // };

  const onSplitOrder = () => {
    // const body = context.editOrderJSON;
    context.setBackDropOpen(true);
    const body = JSON.parse(JSON.stringify(context.editOrderJSON));

    console.log({ body });

    context.editOrderJSON.OrderLinesCollection.map((ele, index) => {
      // console.log(ele);
      body.OrderLinesCollection[index].LineIncoTerms =
        ele.LineIncoTerms.Code ?? "";
      body.OrderLinesCollection[index].UnitOfQuantity =
        ele.UnitOfQuantity.Unit ?? "";

      body.OrderLinesCollection[index].LineOuterPacksUnit =
        ele.LineOuterPacksUnit.Code ?? "";
      body.OrderLinesCollection[index].LineInnerPacksUnit =
        ele.LineInnerPacksUnit.Code ?? "";

      body.OrderLinesCollection[index].UnitOfDimension =
        ele.UnitOfDimension.Unit ?? "";
      body.OrderLinesCollection[index].LineUnitOfWeight =
        ele.LineUnitOfWeight.Unit ?? "";
      body.OrderLinesCollection[index].LineUnitOfVolume =
        ele.LineUnitOfVolume.Unit ?? "";
      body.OrderLinesCollection[index].LineReqInStoreDate =
        ele.LineReqInStoreDate
          ? moment(ele.LineReqInStoreDate).format("YYYY-MM-DD HH:mm:ss")
          : "";
      body.OrderLinesCollection[index].LineConfirmDate = ele.LineConfirmDate
        ? moment(ele.LineConfirmDate).format("YYYY-MM-DD HH:mm:ss")
        : "";
    });

    context.editOrderJSON.OrderPlanningCollection.map((ele, index) => {
      body.OrderPlanningCollection[index].PlanningOriginCountryName =
        ele.PlanningOriginCountryName.Description;
      body.OrderPlanningCollection[index].IsFreezed = false;
      body.OrderPlanningCollection[index].PlanningOriginCountryCode =
        ele.PlanningOriginCountryName.Code;

      body.OrderPlanningCollection[index].PlanningDestinationCountryName =
        ele.PlanningDestinationCountryName.Description;
      body.OrderPlanningCollection[index].PlanningDestinationCountryCode =
        ele.PlanningDestinationCountryName.Code;

      body.OrderPlanningCollection[index].PlanningOriginPortCode =
        ele.PlanningOriginPortName.key;
      body.OrderPlanningCollection[index].PlanningOriginPortName =
        ele.PlanningOriginPortName.name;

      body.OrderPlanningCollection[index].PlanningDestinationPortCode =
        ele.PlanningDestinationPortName.key;
      body.OrderPlanningCollection[index].PlanningDestinationPortName =
        ele.PlanningDestinationPortName.name;

      body.OrderPlanningCollection[index].PlanningSendingAgentPK =
        ele.PlanningSendingAgentCode.OrgPk;
      body.OrderPlanningCollection[index].PlanningSendingAgentCode =
        ele.PlanningSendingAgentCode.OrgName;

      body.OrderPlanningCollection[index].PlanningReceivingAgentPK =
        ele.PlanningReceivingAgentCode.OrgPk;
      body.OrderPlanningCollection[index].PlanningReceivingAgentCode =
        ele.PlanningReceivingAgentCode.OrgName;

      body.OrderPlanningCollection[index].PlanningCarrierPK =
        ele.PlanningCarrierCode.OrgPk;
      body.OrderPlanningCollection[index].PlanningCarrierCode =
        ele.PlanningCarrierCode.OrgCode;

      body.OrderPlanningCollection[index].PlanningCutOfDate =
        ele.PlanningCutOfDate
          ? moment(ele.PlanningCutOfDate).format("YYYY-MM-DD HH:mm:ss")
          : "";
      body.OrderPlanningCollection[index].PlanningEstimatedDepart =
        ele.PlanningEstimatedDepart
          ? moment(ele.PlanningEstimatedDepart).format("YYYY-MM-DD HH:mm:ss")
          : "";
      body.OrderPlanningCollection[index].PlanningEstimatedArrival =
        ele.PlanningEstimatedArrival
          ? moment(ele.PlanningEstimatedArrival).format("YYYY-MM-DD HH:mm:ss")
          : "";
      body.OrderPlanningCollection[index].PlanningOrderReadyDate =
        ele.PlanningOrderReadyDate
          ? moment(ele.PlanningOrderReadyDate).format("YYYY-MM-DD HH:mm:ss")
          : "";
      body.OrderPlanningCollection[index].PlanningFinalDestination =
        ele.PlanningFinalDestination.Description;

      body.OrderPlanningCollection[index].PlanningForwarderCarrier =
        ele.PlanningForwarderCarrier.value ?? "";

      ele.OrderPlanningContainerCollection.map((item, i, arr) => {
        console.log(
          { item },
          ele.OrderPlanningContainerCollection[i].ContainerWeightUnit,
          ele.OrderPlanningContainerCollection[i].ContainerType
        );
        body.OrderPlanningCollection[index].OrderPlanningContainerCollection[
          i
        ].ContainerType = item.ContainerType.Mode;
        body.OrderPlanningCollection[index].OrderPlanningContainerCollection[
          i
        ].ContainerWeightUnit = item.ContainerWeightUnit.Unit;
      });

      console.log("ele.OrderPlanningContainerCollection.", body);
    });

    console.log({ body });
    instance
      .post(path.SPLIT_ORDER, body)
      .then((res) => {
        if (res.Is_Success) {
          context.setDashBoardBody({
            page: 0,
            dataLength: 0,
            hasMore: true,
            pageSize: 10,
          });
          context.setDashboardData({});
          setPlacedData({ ...placedData, data: [] });
          // context.setPlacedOrders({});
          // context.setApprovedOrders({});
          // context.setLoadedOrders({});
          // context.setRejectedOrders({});
          NotificationManager.success(res.Message, "", 3000);
          context.setModalOpen(false);
        } else {
          NotificationManager.error(res.Message, "", 3000);
        }
        context.setBackDropOpen(false);
      })
      .catch((err) => {
        if (err.response) {
          NotificationManager.error(err.response.data.Message, "", 3000);
        } else if (err.request) {
        } else if (err.message) {
        } else {
          NotificationManager.error("Something went wrong!", "", 3000);
        }
        context.setBackDropOpen(false);
      });
  };

  return (
    <ModalBox>
      <div className="_modalBody">
        <div className="_modalSvg">
          <Incomplete_svg />
        </div>
        <p className="_modalText">
          Quantity received is not equal to Quantity Ordered, kindly split the
          order
        </p>
      </div>
      <div className="_modalFooter justify-content-between">
        <div className="_outlineButton">
          <button onClick={onSplitOrder}>Split Order</button>
        </div>
        <div className="_solidButton">
          {/* <button onClick={() => {}}>Create new Order</button> */}
        </div>
      </div>
    </ModalBox>
  );
}

export default EmptyData;
